export default __webpack_public_path__ + "static/media/header.3c338f9e.png";